import {
  getLockValue,
  getSettingsDataInstance,
  getShadowFabricInstance,
  sortBySufix,
  unFocusObjects
} from '@frontend/utils';
import { ADDITIONAL_RECTANGLE_PREFIX_ID } from '@frontend/constants/templates-field-prefixes';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { fabric } from 'fabric';
import { FIELD_TYPE_RECTANGLE } from '@frontend/constants/type-fields-of-template';
import { scaleControlsCornerSize } from '@frontend/constants/fabric-constants';
import { createGradient } from '@frontend/utils/gradient-helper';
import {getGroupNameByAddFieldId} from "@/common/preview/draw-smart-object";
const getScopePage = () => ShowPageScopeCollector.get(['canvas_data']);

export function drawAdditionalRectangle({ canvas, id }) {
  unFocusObjects();

  canvas.getObjects().forEach(function (o) {
    if (o.id.startsWith(ADDITIONAL_RECTANGLE_PREFIX_ID)) {
      canvas.remove(o);
    }
  });

  const { canvas_data } = getScopePage();

  const settingsTemplate = getSettingsDataInstance(canvas_data[id]._data?.settings_template);
  const additionalRectangles = sortBySufix(canvas_data[id].additionalRectangles);
  additionalRectangles.forEach((field, index) => {
    const fill_color = canvas_data[id]._data[field + '_fill_color'];
    const strokecolor = canvas_data[id]._data[field + '_stroke_color'];
    const offset_x = canvas_data[id]._data[field + '_offset_x'] || '0';
    const offset_y = canvas_data[id]._data[field + '_offset_y'] || '0';
    const opacity = parseFloat(canvas_data[id]._data[field + '_opacity']) || 1;
    const corner_radius = parseFloat(canvas_data[id]._data[field + '_corner_radius']);
    const thickness = parseFloat(canvas_data[id]._data[field + '_thickness']) || 0;
    const width = (parseFloat(canvas_data[id]._data[field + '_width'])) - thickness || 300;
    const height = parseFloat(canvas_data[id]._data[field + '_height']) - thickness || 300;
    const toggleShape = canvas_data[id]._data[field + '_toggle_shape'] !== undefined && canvas_data[id]._data[field + '_toggle_shape'] === 'on';
    const angle = parseInt(canvas_data[id]._data[field + '_angle']);
    const visible = canvas_data[id]._data[field + '_visible'] ?? true;
    const corners = canvas_data[id]._data[field + '_corners'] !== undefined ? JSON.parse(canvas_data[id]._data[field + '_corners']) : [0, 0, 0, 0];
    const objectId = ADDITIONAL_RECTANGLE_PREFIX_ID + index;
    const gradient = canvas_data[id]._data[`${field}_gradient`];
    const fillType = canvas_data[id]._data[`${field}_fill_type`];
    let fieldsOrderReassignedByUser = canvas_data[id]._data.users_fields_order;
    fieldsOrderReassignedByUser = fieldsOrderReassignedByUser ? JSON.parse(canvas_data[id]._data.users_fields_order) : false;
    const order = fieldsOrderReassignedByUser
      ? fieldsOrderReassignedByUser.indexOf(objectId) : (parseInt(canvas_data[id]._data[field + '_order']) || 800);
    
    if (toggleShape !== undefined && !toggleShape) {
      return;
    }
    
    const x = 0;
    const y = 0;
    const rect = new fabric.CustomRect({
      id: objectId,
      element_id: field,
      top: y + (parseFloat(offset_y) || 0),
      left: x + (parseFloat(offset_x) || 0),
      width: width,
      height: height,
      fill: getFillStyle({ fillType, fill_color, gradient, width, height }),
      stroke: strokecolor,
      strokeWidth: thickness,
      selectable: true,
      evented: true,
      opacity: opacity,
      corners: corners,
      rx: corner_radius,
      ry: corner_radius,
      order,
      name: settingsTemplate.getNameById(objectId, 'Additional Rectangle ' + (index + 1)),
      link: settingsTemplate.getLinkById(objectId, ''),
      strokeUniform: true,
      fieldType: FIELD_TYPE_RECTANGLE,
      shadow: getShadowFabricInstance(id, field),
      locked: getLockValue(id, field),
      angle: angle,
      visible,
      gradient,
      fillType,
      groupName: getGroupNameByAddFieldId(
        objectId,
        canvas_data[id]
      )
    });
    rect.setControlsVisibility({
      tr: true,
      br: true,
      bl: true,
      ml: true,
      mt: true,
      mr: true,
      mb: true,
      mtr: true,
    });
    canvas_data[id].additionalRectCoords.push({
      x: x + parseFloat(offset_x),
      y: y + parseFloat(offset_y),
    });
    scaleControlsCornerSize(rect);

    canvas.add(rect);
  });
}

function getFillStyle({ fillType, fill_color, gradient, width, height }) {
  if (!fillType || fillType === 'solid') {
    return fill_color;
  }

  if (fillType === 'gradient' && gradient) {
    try {
      const gradientData = typeof gradient === 'string' ? JSON.parse(gradient) : gradient;
      return createGradient(gradientData);
    } catch (e) {
      console.error('Error parsing gradient:', e);
      return fill_color;
    }
  }
  
  return fill_color;
}
